import type { ComponentType, SVGProps } from 'react';

import { cn } from '@/shared/lib/cn';

export type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

export interface IconProps {
  icon: IconComponent;
  size?: string;
  color?: string;
  className?: string;
}

export function Icon({
  icon: IconComponent,
  size,
  color,
  className,
}: IconProps) {
  return <IconComponent className={cn(size, color, className)} />;
}
